import {groupRiskStatus} from '../../../util/uiconstants';

import selectComponentRisks from './selectComponentRisks';

export default () => {
	const componentRisks = selectComponentRisks();
	const filterIt = ({groupRiskStatusId}) =>
		groupRiskStatusId === groupRiskStatus.unmapped || groupRiskStatusId === groupRiskStatus.mapped;
	return componentRisks.filter(filterIt);
};
